"use client"
import React from 'react';
import { motion } from 'framer-motion';
import { Project } from '@/data/projects';
import { fadeInUp, staggerContainer, scaleOnHover } from '../animations';

interface ProjectMetricsProps {
  project: Project;
}

export const ProjectMetrics: React.FC<ProjectMetricsProps> = ({ project }) => {
  if (!project.metrics) return null;

  // Determine grid columns based on number of metrics
  const gridCols = project.metrics.length === 2 ? 'md:grid-cols-2' : 'md:grid-cols-3';

  return (
    <motion.div
      className={`grid grid-cols-1 ${gridCols} gap-6 mb-16`}
      variants={staggerContainer}
      initial="initial"
      animate="animate"
    >
      {project.metrics.map((metric, index) => (
        <motion.div
          key={index}
          className="bg-white/5 p-6 rounded-lg"
          variants={fadeInUp}
          whileHover={scaleOnHover.hover}
          transition={scaleOnHover.transition}
        >
          <h3 className="text-2xl font-bold text-pink-500 mb-2">{metric.value}</h3>
          <p className="text-lg font-semibold text-white mb-2">{metric.label}</p>
          <p className="text-gray-300">{metric.description}</p>
        </motion.div>
      ))}
    </motion.div>
  );
}; 